import { gsap } from "gsap";
import type { Ref, CSSProperties } from "vue";

/**
 *
 * @param activeName
 * @param tabs
 * @returns
 * tab -> acitvename 2
 *    tabItem 1
 *    tabItem 2
 *    tabItem 3
 */
export const useAnimation = (activeName: Ref<string>, tabs: Ref<{ name: string; el: HTMLElement }[]>) => {
    if (!process.client) return;

    // const activeClassName = "active";

    watch(
        () => activeName.value,
        (newValue, oldValue) => {
            handleExpand(newValue);
            handleClose(oldValue);
        }
    );

    async function handleExpand(name: string) {
        const el = tabs.value.find((item) => item.name === name)?.el as HTMLElement;
        if (!el) return;
        let height = el.scrollHeight;
        await gsap.fromTo(el, { height: 0 }, { height: height || "auto", duration: 0.3 });

        await nextTick();
        const childNode = el.children.item(0);
        /**暂时只获取第一个进行，高度的检测 */
        if (childNode) {
            /**如果el的高度发生变化 则需要继续扩大到该高度 */
            const observer = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (entry.target === childNode) {
                        const _height = entry.target.scrollHeight;
                        if (_height === height) return;

                        height = _height;

                        gsap.to(el, { height: _height, duration: 0.3 });
                    }
                }
            });

            observer.observe(childNode);
            Object.assign(el, { observer });
        }
    }

    function handleClose(name: string) {
        const el = tabs.value.find((item) => item.name === name)?.el as HTMLElement;
        (el as any)?.observer?.disconnect();
        gsap.to(el, { height: 0, duration: 0.3 });
    }

    onMounted(() => {
        const defaultName = activeName.value;
        const defaultTabs = tabs.value;

        defaultTabs.map(({ name, el }) => {
            const defualtStyle: CSSProperties = { overflow: "hidden" };
            if (name !== defaultName) {
                defualtStyle.height = 0;
            }

            gsap.set(el, defualtStyle);
        });
        /**如果发现el的高度发生变化，则需要重新计算 */
    });

    onUnmounted(() => {
        tabs.value = [];
    });
};
